import { useEffect } from 'react'
import type { VFC } from 'react'
import { Avatar, AvatarProps } from '.'

type PropsFromConnected = {
  currentUser: {
    name?: string
    [key: string]: unknown
  }
  avatarUuid: string
  getMe: () => void
}

export type CurrentUserAvatarProps = Omit<AvatarProps, 'avatarUuid' | 'name'> &
  PropsFromConnected

export const CurrentUserAvatar: VFC<CurrentUserAvatarProps> = ({
  currentUser,
  avatarUuid,
  getMe,
  iconGlyph = 'person',
  onClick,
  displayRole = true,
  size,
  styleOverrides,
  theme = 'light',
  unread = false,
  withPopover = false,
}) => {
  useEffect(() => {
    if (currentUser === undefined) {
      getMe()
    }
  }, [currentUser, getMe])

  if (currentUser === undefined && avatarUuid === null) return null

  return (
    <Avatar
      avatarUuid={typeof avatarUuid === 'string' ? avatarUuid : undefined}
      displayRole={displayRole}
      iconGlyph={iconGlyph}
      name={currentUser?.name}
      onClick={onClick}
      size={size}
      styleOverrides={styleOverrides}
      theme={theme}
      unread={unread}
      withPopover={withPopover}
    />
  )
}
CurrentUserAvatar.displayName = 'Kuiper: CurrentUserAvatar ← Avatar'
